<script>
    import Chart from 'chart.js';
    import {generateChart} from 'vue-chartjs';

    Chart.defaults.global.defaultFontFamily = "'museo', sans-serif";
    Chart.defaults.global.defaultFontStyle = 'bold';
    Chart.defaults.global.defaultFontSize = 13;
    Chart.defaults.global.defaultFontColor = '#5B5759';

    const Bar = generateChart('bar', 'bar');

    export default {
        extends: Bar,

        props: {
            chartDataProp: Object,
            parentYear: String,
        },
        data() {
            return {
                chosenYear: this.parentYear
            }
        },
        computed: {
            datasets() {
                return [
                    {
                        label: 'Openstaand',
                        backgroundColor: '#cbeaf6',
                        data: this.openstaand,
                        borderWidth: 0,
                    },
                    {
                        label: 'Voldaan',
                        backgroundColor: '#d7e4ca',
                        data: this.voldaan,
                        borderWidth: 0,
                    },
                    {
                        label: 'Ontvangen',
                        backgroundColor: '#f2b6b7',
                        data: this.ontvangen,
                        borderWidth: 0,
                    }
                ]
            },
            openstaand() {
                let values = [];
                if (this.chartDataProp[this.chosenYear]['Openstaand'] !== undefined) {
                    for (let i = 1; i <= 12; i++) {
                        values.push(this.chartDataProp[this.chosenYear]['Openstaand'][i] !== undefined ? this.chartDataProp[this.chosenYear]['Openstaand'][i] : 0);
                    }
                }

                return values;
            },
            voldaan() {
                let values = [];
                if (this.chartDataProp[this.chosenYear]['Openstaand'] !== undefined) {
                    for (let i = 1; i <= 12; i++) {
                        values.push(this.chartDataProp[this.chosenYear]['Voldaan'][i] !== undefined ? this.chartDataProp[this.chosenYear]['Voldaan'][i] : 0);
                    }
                }

                return values;
            },
            ontvangen() {
                let values = [];
                if (this.chartDataProp[this.chosenYear]['Ontvangen'] !== undefined) {
                  for (let i = 1; i <= 12; i++) {
                      values.push(this.chartDataProp[this.chosenYear]['Ontvangen'][i] !== undefined ? this.chartDataProp[this.chosenYear]['Ontvangen'][i] : 0);
                  }
                }

                return values;
            },
        },
        watch: {
            parentYear(val) {
                this.chosenYear = val;
                this.render();
            }
        },
        mounted() {
            this.render();
        },
        methods: {
            render() {
                this.renderChart(
                    {
                        labels: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
                        datasets: this.datasets,
                    },
                    {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [
                                {
                                    display: true,
                                    ticks: {
                                        display: true,
                                    },
                                    labels: this.labels,
                                    gridLines: {
                                        display: false,
                                    },
                                    stacked: true,
                                    barPercentage: 0.65,
                                },
                            ],
                            yAxes: [
                                {
                                    labels: false,
                                    ticks: {
                                        display: false,
                                    },
                                    gridLines: {
                                        drawBorder: false,
                                        borderDash: [8, 6],
                                        color: '#acacac',
                                        lineWidth: .5
                                    },
                                    stacked: true,
                                },
                            ],
                        },
                        legend: {
                            display: true,
                            position: 'bottom',
                            labels: {
                                usePointStyle: true,
                            },
                            onHover(e) {
                                e.target.style.cursor = 'pointer';
                            },
                        },
                        hover: {
                            onHover(e) {
                                let point = this.getElementAtEvent(e);

                                e.target.style.cursor = point.length ? 'pointer' : 'default';
                            },
                        },
                        title: { // tonen we niet
                            display: true,
                            lineHeight: 1, // nodig vanwege: https://github.com/chartjs/Chart.js/issues/4790
                        },
                        tooltips: {
                            enabled: false,
                            mode: 'index',
                            position: 'nearest',
                            custom: this.customTooltips
                        }
                    }
                );
            },
            customTooltips(tooltip) {
                // Tooltip Element
                let tooltipEl = document.getElementById('chartjs-tooltip');

                if (!tooltipEl) {
                    tooltipEl = document.createElement('div');
                    tooltipEl.id = 'chartjs-tooltip';
                    tooltipEl.innerHTML = '<table></table>';
                    this.$el.parentNode.appendChild(tooltipEl);
                }

                // Hide if no tooltip
                if (tooltip.opacity === 0) {
                    tooltipEl.style.opacity = 0;
                    return;
                }

                // Set caret Position
                tooltipEl.classList.remove('above', 'below', 'no-transform');
                if (tooltip.yAlign) {
                    tooltipEl.classList.add(tooltip.yAlign);
                } else {
                    tooltipEl.classList.add('no-transform');
                }

                function getBody(bodyItem) {
                    return bodyItem.lines;
                }

                // Set Text
                if (tooltip.body) {
                    let titleLines = tooltip.title || [];
                    let bodyLines = tooltip.body.map(getBody);

                    let innerHtml = '<thead>';

                    titleLines.forEach(function (title) {
                        // Dit moet zo omslachtig, want de labels zelf kunnen niet gewijzigd worden zonder dat de grafiek stuk gaat
                        let labels = {
                            jan: 'januari',
                            feb: 'februari',
                            mrt: 'maart',
                            apr: 'april',
                            mei: 'mei',
                            jun: 'juni',
                            jul: 'juli',
                            aug: 'augustus',
                            sep: 'september',
                            okt: 'oktober',
                            nov: 'november',
                            dec: 'december'
                        };

                        let longTitle = _.find(labels, (l, key) => {
                            return key === title
                        });

                        innerHtml += '<tr><th>' + longTitle + '</th></tr>';
                    });
                    innerHtml += '</thead><tbody>';

                    bodyLines.forEach(function (body, i) {
                        let colors = tooltip.labelColors[i];
                        let style = 'background:' + colors.backgroundColor;
                        style += '; border-color:' + colors.borderColor;
                        style += '; border-width: 2px';
                        let span = '<span class="chartjs-tooltip-key" style="' + style + '"></span>';
                        innerHtml += '<tr><td>' + span + body.toString().replace(': ', ': €').replace('.', ',') + '</td></tr>';
                    });
                    innerHtml += '</tbody>';

                    let tableRoot = tooltipEl.querySelector('table');
                    tableRoot.innerHTML = innerHtml;
                }

                let positionY = this.$el.offsetTop;
                let positionX = this.$el.offsetLeft;

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1;
                tooltipEl.style.left = positionX + tooltip.caretX + 'px';
                tooltipEl.style.top = positionY + tooltip.caretY + 'px';
                tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
                tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px';
                tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
                tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
            },
        }

    }
</script>

<style>
  canvas {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    width: 100%;
  }

  #chartjs-tooltip {
    opacity: 1;
    position: absolute;
    background: white;
    color: #5B5759;
    border-radius: 3px;
    transition: all .1s ease;
    pointer-events: none;
    transform: translate(-50%, 0);
    box-shadow: 0 0 15px 0 rgba(0, 154, 212, 0.35);
  }

  .chartjs-tooltip-key {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 10px;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/components/MijnBetalingenChart.vue